export const PHONE = "02 8717 7344";
export const PHONE_HREF = "tel:+390287177344";
export const PARTNER_EMAIL = "rete@nexusitaliagroup.com";
export const SLOGAN = "ESSERCI. INSIEME. SEMPRE E OVUNQUE.";
export const PEC = "nexusitaliagroup@pec.it";
export const COMPANY = {
  name: "Nexus Italia Group SRLs",
  legal: "Via Marcantonio Colonna, 12, 20149 Milano (MI)",
  operational: "Via dei Calchi Taeggi, 27, 20152 Milano (MI)",
  vat: "14929530963",
};

export const CONSULENZA = [
  "Supporto organizzativo, formativo e amministrativo",
  "Creazione e gestione del parco fornitori",
  "Supporto allo sviluppo",
];

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/servizi", label: "Servizi" },
  { to: "/centrale-operativa", label: "Centrale Operativa" },
  { to: "/diventa-partner", label: "Diventa partner" },
  { to: "/contatti", label: "Contatti" },
];

export const NEEDS = [
  { value: "trasporto", label: "Trasporto sanitario" },
  { value: "taxi", label: "Taxi sanitario" },
  { value: "evento", label: "Assistenza a un evento" },
  { value: "corsi", label: "Corsi di formazione" },
  { value: "convenzione", label: "Convenzione per strutture" },
  { value: "partner", label: "Diventare partner" },
  { value: "altro", label: "Altro" },
];

export const requestLink = (need) => `/contatti?tipo=${need}#modulo`;

export const SERVICES = [
  {
    slug: "trasporti-sanitari-non-urgenti",
    icon: "Ambulance",
    title: "Trasporti sanitari non urgenti",
    short: "Ambulanze per visite, ricoveri programmati, dimissioni e trasferimenti, organizzati in base alle esigenze di ogni persona.",
    intro:
      "Organizziamo trasporti sanitari programmati con ambulanza per chi ha bisogno di spostarsi in sicurezza: dal domicilio verso ospedali, cliniche e centri diagnostici, tra strutture sanitarie e di ritorno a casa. Ogni trasporto viene pianificato dalla Centrale Operativa e affidato al partner più adatto per mezzi, competenze e area territoriale.",
    listTitle: "Cosa organizziamo",
    items: [
      "Trasporti in ambulanza per visite ed esami",
      "Ricoveri programmati",
      "Dimissioni e rientri a domicilio",
      "Trasferimenti tra ospedali, cliniche e RSA",
      "Trasporti per terapie ricorrenti",
      "Trasporti di pazienti allettati",
      "Trasporti di media e lunga percorrenza",
      "Trasferimenti nazionali e internazionali",
      "Accompagnamento sanitario, quando previsto",
    ],
    message:
      "Ogni persona ha esigenze diverse. Noi organizziamo il trasporto più adatto, mettendo al centro sicurezza, professionalità e attenzione.",
    cta: "Richiedi un trasporto sanitario",
    need: "trasporto",
    photo: "/media/ambulanza-nexus.jpg",
    photoPosition: "center",
  },
  {
    slug: "taxi-sanitario-trasporto-assistito",
    icon: "Accessibility",
    title: "Taxi sanitario e trasporto assistito",
    short: "Mobilità assistita con autovetture e veicoli attrezzati, anche per carrozzina, per visite, terapie e spostamenti ricorrenti.",
    intro:
      "Non tutti gli spostamenti richiedono un'ambulanza. Per chi può viaggiare seduto o in carrozzina, organizziamo trasporti assistiti con autovetture e veicoli attrezzati, con la stessa cura nella pianificazione e la stessa attenzione alla persona.",
    listTitle: "Soluzioni disponibili",
    items: [
      "Trasporti in autovettura",
      "Veicoli attrezzati",
      "Trasporti per persone in carrozzina",
      "Accompagnamento a visite ed esami",
      "Trasporti per cicli terapeutici",
      "Trasporti ricorrenti",
      "Servizi per anziani e persone con mobilità ridotta",
    ],
    message: "La soluzione giusta per ogni esigenza di mobilità assistita.",
    cta: "Richiedi un taxi sanitario",
    need: "taxi",
    photo: "/media/ill-taxi.jpg",
  },
  {
    slug: "assistenza-sanitaria-eventi",
    icon: "CalendarCheck",
    title: "Assistenza sanitaria a eventi e manifestazioni",
    short: "Pianificazione e coordinamento della copertura sanitaria per eventi sportivi, culturali, aziendali e privati, anche su più sedi.",
    intro:
      "Un evento sereno nasce da un'organizzazione accurata. Pianifichiamo la copertura sanitaria insieme agli organizzatori, valutando tipologia dell'evento, affluenza prevista e luoghi, e coordiniamo i partner coinvolti, anche quando l'evento si svolge su più sedi.",
    listTitle: "Per quali eventi",
    items: [
      "Eventi sportivi e tornei",
      "Manifestazioni cittadine",
      "Concerti",
      "Fiere",
      "Eventi aziendali",
      "Eventi culturali e privati",
    ],
    secondTitle: "Cosa mettiamo a disposizione",
    secondItems: [
      "Ambulanze",
      "Soccorritori",
      "Personale sanitario, quando richiesto",
      "Postazioni sanitarie",
      "Coordinamento e pianificazione della copertura",
      "Gestione di eventi su più sedi",
    ],
    message: "Ogni grande evento ha bisogno di un'organizzazione sanitaria all'altezza.",
    cta: "Richiedi assistenza sanitaria per il tuo evento",
    need: "evento",
    photo: "/media/ill-eventi.jpg",
  },
  {
    slug: "formazione-blsd-primo-soccorso",
    icon: "HeartPulse",
    title: "Formazione BLSD e primo soccorso",
    short: "Corsi BLSD, uso del DAE e primo soccorso per operatori laici e sanitari, con percorsi personalizzati e retraining.",
    intro:
      "Diffondere la cultura del primo soccorso è parte del nostro modo di esserci. Organizziamo corsi per aziende, scuole, associazioni, strutture e privati, tenuti da formatori qualificati nel rispetto dei requisiti applicabili.",
    listTitle: "I percorsi formativi",
    items: [
      "BLSD per operatori laici",
      "BLSD per operatori sanitari",
      "Uso del defibrillatore (DAE)",
      "Primo soccorso",
      "Primo soccorso aziendale",
      "Disostruzione delle vie aeree",
      "Manovre salvavita pediatriche",
      "Percorsi personalizzati",
      "Retraining",
    ],
    message:
      "La conoscenza può fare la differenza. Imparare a intervenire significa essere pronti quando conta davvero.",
    cta: "Scopri i nostri corsi",
    need: "corsi",
    photo: "/media/formazione-rcp.jpg",
    photoPosition: "center top",
  },
  {
    slug: "servizi-rsa-ospedali-strutture",
    icon: "Building2",
    title: "Servizi per RSA, ospedali e strutture sanitarie",
    short: "Un unico interlocutore per trasporti programmati, trasferimenti e dimissioni, con gestione centralizzata e convenzioni dedicate.",
    intro:
      "Le strutture sanitarie e sociosanitarie hanno bisogno di continuità, puntualità e semplicità. Con Nexus la struttura non deve contattare più operatori: la Centrale Operativa raccoglie le richieste, le pianifica e coordina i partner della rete.",
    listTitle: "Strutture con cui lavoriamo",
    items: [
      "RSA",
      "Ospedali",
      "Cliniche",
      "Centri medici e diagnostici",
      "Strutture riabilitative",
      "Comunità",
    ],
    secondTitle: "Servizi per la struttura",
    secondItems: [
      "Trasporti programmati",
      "Trasferimenti tra strutture",
      "Dimissioni",
      "Trasporti ricorrenti",
      "Richieste estemporanee",
      "Servizi dedicati",
      "Gestione centralizzata tramite la Centrale Operativa",
      "Accordi e convenzioni personalizzate",
    ],
    highlight:
      "La struttura non deve contattare più operatori: Nexus centralizza le richieste e coordina il servizio.",
    message: "Un unico interlocutore. Una rete di professionisti. Una gestione più semplice.",
    cta: "Richiedi una convenzione",
    need: "convenzione",
    photo: "/media/ill-strutture.jpg",
  },
  {
    slug: "trasporti-sanitari-speciali",
    icon: "Route",
    title: "Trasporti sanitari speciali e servizi dedicati",
    short: "Lunga percorrenza, trasferimenti internazionali, logistica sanitaria e servizi su misura, valutati caso per caso.",
    intro:
      "Alcune esigenze richiedono un'organizzazione dedicata. Valutiamo ogni richiesta in base alle sue caratteristiche, alle autorizzazioni necessarie e alla disponibilità dei partner, per proporre una soluzione chiara e sostenibile.",
    listTitle: "Servizi su richiesta",
    items: [
      "Trasporti di lunga percorrenza",
      "Trasferimenti internazionali",
      "Servizi dedicati a strutture",
      "Trasporto di materiali sanitari",
      "Logistica sanitaria",
      "Trasporto di sangue ed emocomponenti tramite operatori abilitati",
      "Servizi navetta",
      "Mobilità personalizzata",
    ],
    note: "I servizi vengono valutati in base alla richiesta, alle autorizzazioni previste e alla disponibilità.",
    message: "Quando le esigenze diventano complesse, l'organizzazione fa la differenza.",
    cta: "Parlaci della tua esigenza",
    need: "altro",
    photo: "/media/ill-speciali.jpg",
  },
];

export const PHASES = [
  {
    n: "01",
    title: "Ricezione della richiesta",
    text: "Ascoltiamo la richiesta e raccogliamo le informazioni essenziali: chi, dove, quando e con quali necessità.",
  },
  {
    n: "02",
    title: "Analisi delle esigenze",
    text: "Valutiamo condizioni della persona, tipo di mezzo, eventuale personale e tempi, per definire il servizio più adatto.",
  },
  {
    n: "03",
    title: "Individuazione del partner",
    text: "Selezioniamo, all'interno della rete, il partner operativo più adeguato per competenze, mezzi e area territoriale.",
  },
  {
    n: "04",
    title: "Organizzazione",
    text: "Pianifichiamo il servizio con il partner e confermiamo i dettagli a chi ha fatto la richiesta.",
  },
  {
    n: "05",
    title: "Monitoraggio",
    text: "Seguiamo lo svolgimento del servizio e restiamo un punto di riferimento fino alla sua conclusione.",
  },
];

export const VALUES = [
  { icon: "MapPin", title: "Presenza", text: "Esserci, vicino alle persone e alle strutture, con un riferimento chiaro e raggiungibile." },
  { icon: "ShieldCheck", title: "Professionalità", text: "Metodo, rispetto delle regole e cura in ogni fase del servizio." },
  { icon: "GraduationCap", title: "Competenza", text: "Conoscenze organizzative e sanitarie messe al servizio di ogni richiesta." },
  { icon: "HandHeart", title: "Disponibilità", text: "Ascolto, attenzione e una risposta organizzata a ogni esigenza." },
];
